/*"proxy": "https://gateway-vecinos.penalolen.cl:9443",*/
//const url_produccion = "https://gateway.penalolen.cl:9443";
//const url_produccion = "https://gateway-vecinos.penalolen.cl:9443";
//const url_produccion = "https://calificacionesdev.penalolen.cl/p.php";
const url_produccion = "https://calificaciones.penalolen.cl/p.php";

//const url_desarrollo = window.location.protocol + "//" + window.location.host;
const url_desarrollo = "https://gateway.penalolen.cl:9443";

export const prefix = "/calificaciones"; // ya no sirve este parámetro
export const ambiente_produccion = true; // FALSE: SIN CU SIN BANNER 
export const produccion = true; //cambiar a true y en package.json cambiar proxy

export function url_ws() {
  return produccion == true ? url_produccion : url_desarrollo;
}

export async function loginApi(run, password) {
  const url = url_ws() + "/users";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      run: run,
      password: password,
      application: "calificaciones",
    }),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

///prequalifications/7/process/15/officer

//report-evaluations/7/process
export async function resumenParticipacion(id_proceso) {
  const url = url_ws() + `/report-evaluations/${id_proceso}/process`;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function precalificacionesPrecalificador(
  id_proceso,
  id_funcionario
) {
  const url =
    url_ws() +
    `/prequalifications/${id_proceso}/process/${id_funcionario}/officer`;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function procesosPrecalificador(id_funcionario) {
  const url = url_ws() + "/process/proccess/" + id_funcionario;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function cargarProcesoActivo() {
  const url = url_ws() + "/process/active-proccess";
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function cargarDatosProceso(idProcess) {
  const url = url_ws() + "/process/" + idProcess;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function cargarParticipante(id_participant) {
  const url = url_ws() + "/participants/" + id_participant;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function cargarPrecalificador(id_prequalifier) {
  const url = url_ws() + "/prequalifiers/" + id_prequalifier;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function cargarHistorial(id_participant) {
  const url = url_ws() + "/history/" + id_participant;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status == 200) {
        return response.json();
      } else {
        return null;
      }
    })
    .then((datos) => {
      return datos;
    })
    .catch((data) => {
      return null;
    });
  return response;
}

export async function cargarOfficer(idOfficer) {
  const url = url_ws() + "/officers/" + idOfficer;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}
//
export async function cargarPrecalificaciones(id_participant) {
  const url = url_ws() + `/prequalifications/${id_participant}/evaluations`;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        return null;
      }
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function cargarCalificacionFinal(id_participant) {
  const url = url_ws() + `/qualifications/${id_participant}/participant`;
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta }; //
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

export async function cargarCalificacion(id_calificacion) {
  const url = url_ws() + `/prequalifications/${id_calificacion}/evaluation`;
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta }; //
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

export async function listaFuncionariosNoPrecalificados(payload) {
  //const url_payload = new URLSearchParams(payload);
  const url = url_ws() + "/prequalifications/notprequalificated";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (response.status == 400) {
        return [];
      }
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function listaPendientesValidar(id_participant) {
  const url =
    url_ws() + "/prequalifications/" + id_participant + "/participant";
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status == 400) {
        return [];
      }
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

/**/
export async function cargarNoNotificados(idProcess) {
  const url = url_ws() + `/qualifications/${idProcess}/notnotified`;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status == 200) {
        return response.json();
      } else {
        return null;
      }
    })
    .then((datos) => {
      return datos;
    })
    .catch((data) => {
      return null;
    });
  return response;
}



/*CU??*/
export async function cargarListarSinCorreo(idProcess) {
  const url = url_ws() + `/participants/${idProcess}/noMail`;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status == 200) {
        return response.json();
      } else {
        return null;
      }
    })
    .then((datos) => {
      return datos;
    })
    .catch((data) => {
      return null;
    });
  return response;
}

/**/
export async function cargarNotificados(idProcess) {
  const url = url_ws() + `/qualifications/${idProcess}/notified`;
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status == 200) {
        return response.json();
      } else {
        return null;
      }
    })
    .then((datos) => {
      return datos;
    })
    .catch((data) => {
      return null;
    });
  return response;
}

export async function buscarParticipante(rut, idProcess) {
  const url = url_ws() + `/participants/search`;
  const datos = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id_process: idProcess,
      officerRut: rut,
    }),
  }).then(async (response) => {
    try {
      const respuesta = await response.json();
      if (response.status == 400) {
        return { status: false, errores: respuesta.errors };
      } else {
        return { status: true, datos: respuesta };
      }
    } catch (error) {
      return {
        status: false,
        errores: ["No existe participante asociado al RUT consultado"],
      };
    }
  });
  return datos;
}
export async function crearSesion(idProcess) {
  const url = url_ws() + `/sessions`;
  const datos = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      id_process: idProcess,
      createdUser: "RESCOBAR",
    }),
  }).then(async (response) => {
    if (response.status == 201) {
      return { status: true };
    } else {
      const respuesta = await response.json();
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}

export async function finalizarSesion(hora, archivo) {
  const url = url_ws() + `/sessions`;
  const datos = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      endTime: hora,
      doc_MinutesOfSession: archivo,
    }),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}

export async function cargarSesionActiva() {
  const url = url_ws() + `/sessions`;
  const datos = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}

/*  */
export async function calificacionesPendientes(id_process) {
  const url = url_ws() + `/qualifications/${id_process}/pending`;
  const datos = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}

/**/
export async function calificacionesPorRevisar(id_process) {
  const url = url_ws() + `/qualifications/${id_process}/to-reviewed`;
  const datos = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}

export async function cargarPrequalificationsFilter(payload) {
  const url = url_ws() + `/prequalifications/filter`;

  const respuesta = fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (response.status !== 200) {
        return null;
      } else {
        return response.json();
      }
    })
    .then((result) => {
      return result;
    });
  return respuesta;
}

/*  */
export async function actualizarRatificacion(payload) {
  const url = url_ws() + `/ratifications`;
  const datos = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}
/*  */
export async function cerrarProceso(id_process) {
  const url = url_ws() + `/process/${id_process}`;
  const datos = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}
/*  */
export async function marcarPorRevisar(id_qualifications) {
  const url = url_ws() + `/qualifications/${id_qualifications}/check`;

  const datos = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}

export async function verificarNotificacion(payload) {
  //const url_payload = new URLSearchParams(payload);
  const url = url_ws() + "/qualifications/verify-notify";
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (response.status == 400) {
        return null;
      }
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function enviarConformidad(payload) {
  //const url_payload = new URLSearchParams(payload);
  const url = url_ws() + "/qualifications/conformity";
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return response;
}

export async function cargarRatificadas(idProcess) {
  const url = url_ws() + `/ratifications/${idProcess}/ratification`;
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, datos: [], errores: respuesta.errors };
    }
  });
  return response;
}

export async function cargarPorRatificar(idProcess) {
  const url = url_ws() + `/ratifications/${idProcess}/notratification`;
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, datos: [], errores: respuesta.errors };
    }
  });
  return response;
}

export async function cargarCalificacionesFuncionario(id_officer) {
  const url = url_ws() + `/qualifications/${id_officer}/participant`;
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, datos: [], errores: respuesta.errors };
    }
  });
  return response;
}

export async function firmarApelacion(id) {
  const url = url_ws() + `/appeals/${id}/sign`;
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, datos: [], errores: respuesta.errors };
    }
  });
  return response;
}

export async function descargarDocumentos(id) {
  const url = url_ws() + `/qualifications/${id}/documents`;
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, datos: [], errores: respuesta.errors };
    }
  });
  return response;
}

/** */
export async function finalizarApelacion(payload) {
  const url = url_ws() + `/appeals/finish`;
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body:JSON.stringify(payload)
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}
/*
export async function finalizarApelacion(id_qualifications) {
  const url = url_ws() + `/appeals/${id_qualifications}/finish`;
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}*/

//
export async function cargarApelaciones(idProcess) {
  const url = url_ws() + `/appeals/${idProcess}/appeal`;
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 400) {
      return { status: false, errores: respuesta.errors };
    }
    return { status: true, datos: respuesta };
  });
  return response;
}

export async function unidadesPorDireccion(idDireccion, usarNombre = false) {
  const url =
    url_ws() + "/unity-management/" + idDireccion + "/unitsByDirection";
  const opciones = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status == 400) {
        return [];
      } else {
        return response.json();
      }
    })
    .then((datos) => {
      const opciones = datos.map((d) => {
        return {
          value: usarNombre ? d.nameUmunicipal : d.id_Umunicipal,
          label: d.nameUmunicipal,
        };
      });
      return opciones;
    });
  return opciones;
}

export const actualizarParticipanteApi = async (payload) => {
  const url = url_ws() + "/participants/updatePart";
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 400) {
      return { status: false, errores: respuesta.errors };
    }
    return { status: true, datos: respuesta };
  });
  return response;
};

export async function enviarPrecalificacion(payload) {
  const url = url_ws() + "/prequalifications";
  const response = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    if (response.status == 400) {
      const respuesta = await response.json();
      return { status: false, errores: respuesta.errors };
    } else {
      return { status: true };
    }
  });
  return response;
}

export async function listaPendientesAutorizar() {
  const url = url_ws() + "/prequalifications/listAuthorization";
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

export async function listaPrecalificadores() {
  const url = url_ws() + "/officers/fea";
  const response = await fetch(url, {
    method: "GET",
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return response;
}

export const asignarPaarticipantes = async (idProcess) => {
  const url = url_ws() + "/participants/" + idProcess;
  console.log("Fetch");
  console.log(url);
  const respuesta = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });
  return respuesta;
};

export async function eliminarProcesoApi(payload) {
  const url = url_ws() + "/process";
  const respuesta = await fetch(url, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    if (response.status == 200) {
      return { status: true };
    } else {
      const respuesta = await response.json();
      return { status: false, errores: respuesta.errors };
    }
  });
  return respuesta;
}

export async function listaParticipantesExcluidos(idProcess) {
  await new Promise((r) => setTimeout(r, 2000));
  const url = url_ws() + `/participants/${idProcess}/excluded`;
  const datos = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status == 400) {
        return [];
      } else {
        return response.json();
      }
    })
    .then((datos) => {
      return datos;
    });
  return datos;
}

export async function autorizarPrecalificacion(id_prequalifications) {
  const url = url_ws() + `/prequalifications/` + id_prequalifications;
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    if (response.status == 400) {
      const respuesta = await response.json();
      return { status: false, errores: respuesta.errors };
    } else {
      return { status: true };
    }
  });
  return response;
}

//BUSCAR CALIFICACIÓN,  RUTH
export async function buscar(payload) {
  const url = url_ws() + "/qualifications/search";
  const datos = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  })
    .then((response) => {
      if (response.status == 400) {
        return [];
      } else {
        return response.json();
      }
    })
    .then((datos) => {
      return datos;
    });
  return datos;
}

export async function verProceso(payload) {
  const url = url_ws() + "/process/searcher";
  const respuesta = await fetch(url, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then(async (response) => {
      const texto = await response.text();
      if (response.status === 200 && texto != "") {
        return JSON.parse(texto);
      } else {
        return [];
      }
    })
    .then((datos) => {
      return datos;
    });

  return respuesta;
}
export async function validarEvaluacion(payload) {
  const url = url_ws() + "/prequalifications/";
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    if (response.status == 400) {
      const respuesta = await response.json();
      return { status: false, errores: respuesta.errors };
    } else {
      return { status: true };
    }
  });
  return response;
}

export async function procesosPorFuncionario(funcionario_id = null) {
  const url =
    url_ws() + "/participants/" + funcionario_id + "/functionary/process";
  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      if (response.status == 200) {
        return response.json();
      } else {
        return null;
      }
    })
    .then((datos) => {
      return datos;
    })
    .catch((data) => {
      return null;
    });
  return response;
}

/** EVALUAR NOTA*/
export async function enviarNotificaciones(proceso_id=null) {
  const url = url_ws() +`/qualifications/${proceso_id}/evaluate`;
  const response = await fetch(url, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    }
  }).then(async (response) => {
    if (response.status!=200) {
      const respuesta = await response.json();
      return { status: false, errores: respuesta.errors };
    } else {
      return { status: true };
    }
  });
  return response;
}
///{procesoID}/evaluate

export async function cargarNoContestadas(idProcess) {
  const url = url_ws() + `/qualifications/${idProcess}/notreplied`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, datos: [], errores: respuesta.errors };
    }
  });
  return response;
}



//
export async function cargarContestadas(idProcess) {
  const url = url_ws() + `/qualifications/${idProcess}/replied`;
  const response = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status === 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, datos: [], errores: respuesta.errors };
    }
  });
  return response;
}

export async function anularCalificacion(payload) {
  const url = url_ws() + `/prequalifications/cancel`;
  const datos = await fetch(url, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then(async (response) => {
    const respuesta = await response.json();
    if (response.status == 200) {
      return { status: true, datos: respuesta };
    } else {
      return { status: false, errores: respuesta.errors };
    }
  });
  return datos;
}

export async function cargarOfficerPorRut(rut) {
  const url = url_ws() + "/officers/officerRut/" + rut;

  const response = await fetch(url, {
    method: "GET",
  })
    .then((response) => {
      return response.json();
    })
    .then((datos) => {
      return datos;
    });

  return response;
}